import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { setAuthToken, setupErrorInterceptors } from '../api/client';

/**
 * Injects the Auth0 access token into the API client on mount and on token refresh.
 * Place this hook in a layout component that wraps all authenticated pages.
 */
// TODO: re-enable auth after accessibility audit — remove the early return below
export function useApiAuth() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [isApiAuthReady, setIsApiAuthReady] = useState(false);

  // Set up error interceptors once on mount
  useEffect(() => {
    setupErrorInterceptors();
  }, []);

  // Auth bypass: remove the two lines below to restore normal auth behaviour
  // useEffect(() => { setIsApiAuthReady(true); }, []);
  // if (true) return { isApiAuthReady };

  useEffect(() => {
    if (!isAuthenticated) {
      setAuthToken(null);
      setIsApiAuthReady(false);
      return;
    }

    setIsApiAuthReady(false);

    void getAccessTokenSilently()
      .then((token) => {
        setAuthToken(token);
        setIsApiAuthReady(true);
      })
      .catch(() => {
        setAuthToken(null);
        setIsApiAuthReady(false);
      });
  }, [isAuthenticated, getAccessTokenSilently]);

  return { isApiAuthReady };
}
